export const requiredValidation = (value) => value.trim().length > 0;

export const firstCharacterValidation = (value) => /^[A-Za-z0-9]/.test(value);

export const validateInput = (value, setErrorFunc, type, required = true) => {
    value = (value || "").trim();

    if (required && !requiredValidation(value)) {
        setErrorFunc("Required field");
        return false;
    }

    return true;
};

export const validateInputChange = (event, setValueFunc, setErrorFunc, type) => {
    let value = event.target.value;
    
    setValueFunc(value);
    
    if (value.trim() !== '' && !firstCharacterValidation(value)) {
        setValueFunc(value);
        setErrorFunc("First letter cannot be space or special character.");
    } else {
        setErrorFunc("");
    }
};